module.exports = __webpack_public_path__ + "static/media/group.f4ae3ea0.png";